import styled from "@emotion/styled";
import { Box, Typography } from "@mui/material";
import { mediaQueryMobileLimit } from "../../../../../utils/constants";

export const MapStyled = {

  Container: styled(Box) <any>`
  filter: grayscale(100%);
    @media (max-width: ${mediaQueryMobileLimit}px) {
        margin: 0 15px;
       };
    `,
  TitlePopUp: styled(Typography) <any>`
       font-weight: bold;
       font-size: 16px;
    `,
  SubtitlePopUp: styled(Typography) <any>`
      cursor: pointer;
      text-decoration: underline;
      margin-top:10px;
      font-weight: bold;
      font-size: 14px;
    `,




};